/* eslint max-statements: [2, 12], max-params: [2, 6] */
import $ from '../../../util/jquery-wrapper';
import _ from '../../../util/underscore-wrapper';
import Keys from '../../../util/Keys';
import Util from '../../../util/Util';
import BaseView from '../../BaseView';
import 'vendor/plugins/jquery.custominput';
import BaseInput from '../BaseInput';
import hbs from 'handlebars-inline-precompile';

const isABaseView = Util.isABaseView;
const myTmp = hbs`
<input type="radio" name="{{name}}" data-se-name="{{realName}}" value="{{value}}" id="{{optionId}}">
<label for="{{optionId}}" data-se-for-name="{{realName}}" class="radio-label">
  {{label}}
</label>
`;
const RadioRadioOption = BaseView.extend({
  template: myTmp,
  initialize: function (options) {
    let explain;

    explain = options.explain;
    if (_.isFunction(explain) && !isABaseView(explain)) {
      explain = _.resultCtx(this.options, 'explain', this);
    }
    if (!explain) {
      return;
    }

    if (isABaseView(explain)) {
      this.add('<p class="o-form-explain"></p>', '.radio-label');
      this.add(explain, '.o-form-explain');
    } else {
      this.add(BaseView.extend({
        className: 'o-form-explain',
        tagName: 'p',
        template: hbs`{{explain}}`
      }), '.radio-label');
    }
  }
});
export default BaseInput.extend({
  /**
   * @Override
   */
  events: {
    'change :radio': 'update',
    keyup: function (e) {
      if (Keys.isSpaceBar(e)) {
        $(e.target).click();
      } else if (Keys.isEnter(e)) {
        this.model.trigger('form:save');
      }
    }
  },

  /**
   * @Override
   */
  editMode: function () {
    const templates = [];

    this.$el.empty();

    _.each(
      this.options.options,
      function (value, key) {
        const options = {
          optionId: _.uniqueId('option'),
          name: this.options.inputId,
          realName: this.options.name,
          value: key
        };

        if (!_.isObject(value)) {
          value = { label: value };
        }
        _.extend(options, value);

        templates.push(new RadioRadioOption(options).render().el);
      },
      this
    );
    this.$el.append(templates);
    let value = this.getModelValue();

    if (value) {
      this.$(':radio[value=' + value + ']').prop('checked', true);
    }

    this.$('input').customInput();
    this.model.trigger('form:resize');

    if (this.getParam('inline') === true) {
      this.$('div.custom-radio').addClass('inline');
    }

    return this;
  },

  /**
   * @Override
   */
  readMode: function () {
    this.editMode();
    this.$(':radio').prop('disabled', true);
    return this;
  },

  /**
   * @Override
   */
  val: function () {
    return this.$(':radio:checked').val();
  },

  /**
   * @Override
   */
  focus: function () {
    return this.$('label:eq(0)').focus();
  }
});



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/inputs/Radio.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/inputs/Radio.js